import { motion } from "framer-motion";
import { Layers } from "lucide-react";
import { Reveal, SectionLabel, CtaButton } from "@/components/landing/shared";

export const BeyondFirstAd = () => (
  <section id="beyond" className="border-t border-zinc-900 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
        <Reveal>
          <div>
            <SectionLabel index="05" testid="beyond-label">
              Ongoing content
            </SectionLabel>
            <h2 className="mt-6 font-display text-3xl font-bold leading-tight tracking-tight sm:text-5xl">
              Beyond the first ad.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-zinc-400">
              One ad turns heads. A steady stream keeps you selling. Video is how attention moves
              now — so keep feeding the algorithm.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <motion.div
            whileHover={{ y: -4 }}
            transition={{ duration: 0.3 }}
            className="relative overflow-hidden rounded-3xl border border-zinc-800 bg-[#0d0d0d] p-9"
            data-testid="content-pack-card"
          >
            <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-white/[0.04] blur-3xl" />
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-zinc-800 bg-white/[0.03]">
                <Layers className="h-5 w-5 text-zinc-300" />
              </span>
              <div>
                <p className="ff-mono text-[11px] uppercase tracking-widest text-zinc-500">
                  Monthly content-pack
                </p>
                <h3 className="text-xl font-semibold tracking-tight">4–8 videos / month</h3>
              </div>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-zinc-400">
              A steady pipeline of fresh motion ads every month to beat ad fatigue and scale ROAS
              across TikTok, Meta and YouTube. Custom-scoped to your calendar.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["Custom-scoped", "Iterative hooks", "All ratios"].map((t) => (
                <span
                  key={t}
                  className="rounded-full border border-zinc-800 px-3 py-1 ff-mono text-[11px] text-zinc-400"
                >
                  {t}
                </span>
              ))}
            </div>
            <CtaButton testid="beyond-cta" variant="outline" className="mt-8">
              Discuss a content-pack
            </CtaButton>
          </motion.div>
        </Reveal>
      </div>
    </div>
  </section>
);
